/**
 * @generated SignedSource<<be7e7cd3f1db5e7ddc1960703eb15f41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookBookScrapsClassificationDialog_book$data = {
  readonly id: string;
  readonly unclassifiedBookScrapCount: number;
  readonly " $fragmentType": "BookBookScrapsClassificationDialog_book";
};
export type BookBookScrapsClassificationDialog_book$key = {
  readonly " $data"?: BookBookScrapsClassificationDialog_book$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookBookScrapsClassificationDialog_book">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookBookScrapsClassificationDialog_book",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unclassifiedBookScrapCount",
      "storageKey": null
    }
  ],
  "type": "Book",
  "abstractKey": null
};

(node as any).hash = "82d259ca14ad2811671f806f31877a45";

export default node;
